import React, { MouseEventHandler } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useDictionary from '@ui/hooks/useDictionary';
import { emptyFn } from '@core/interfaces/emptyFn';

interface IProps {
    imei: string;
    name: string;
    login: string;
    deviceBtnHover: boolean;
    onDeviceBtnHoverStart: emptyFn;
    onDeviceBtnHoverStop: emptyFn;
    onDeleteDeviceOpen: MouseEventHandler<HTMLElement>;
    onEditSubuserRightsOpen: MouseEventHandler<HTMLElement>;
}

const Component: React.FC<IProps> = ({
    imei,
    name,
    login,
    deviceBtnHover,
    onDeviceBtnHoverStart,
    onDeviceBtnHoverStop,
    onDeleteDeviceOpen,
    onEditSubuserRightsOpen,
}: IProps) => {
    const getWord = useDictionary();
    const popperClass = deviceBtnHover
        ? 'hidden'
        : 'subusers__item-menu-tooltip-popper';

    return (
        <>
            <Tooltip
                classes={{
                    popper: popperClass,
                    tooltip: 'subusers__item-menu-tooltip',
                }}
                title={`IMEI: ${imei}`}
                placement="top"
                followCursor
            >
                <ListItemButton
                    className="subuser-devices__item"
                    component="li"
                    id={`${imei}&${login}`}
                >
                    <ListItemText
                        classes={{
                            root: 'subuser-devices__item-text-wrap',
                            primary: 'subuser-devices__item-text',
                        }}
                        primary={name}
                    />
                    <Tooltip
                        classes={{
                            popper: 'subusers__item-menu-tooltip-popper',
                            tooltip: 'subusers__item-menu-tooltip',
                        }}
                        title={getWord('editSubuserRights')}
                        placement="top"
                        onTouchStartCapture={onDeviceBtnHoverStart}
                        onTouchEndCapture={onDeviceBtnHoverStop}
                        onMouseOver={onDeviceBtnHoverStart}
                        onMouseOut={onDeviceBtnHoverStop}
                        onMouseEnter={onDeviceBtnHoverStart}
                        onFocus={onDeviceBtnHoverStart}
                        onMouseLeave={onDeviceBtnHoverStop}
                        onBlur={onDeviceBtnHoverStop}
                    >
                        <IconButton
                            className="subusers__item-menu-btn"
                            onClick={onEditSubuserRightsOpen}
                        >
                            <EditIcon className="subusers__item-menu-ico" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        classes={{
                            popper: 'subusers__item-menu-tooltip-popper',
                            tooltip: 'subusers__item-menu-tooltip',
                        }}
                        title={getWord('deviceDelete')}
                        placement="top"
                        onTouchStartCapture={onDeviceBtnHoverStart}
                        onTouchEndCapture={onDeviceBtnHoverStop}
                        onMouseOver={onDeviceBtnHoverStart}
                        onMouseOut={onDeviceBtnHoverStop}
                        onMouseEnter={onDeviceBtnHoverStart}
                        onFocus={onDeviceBtnHoverStart}
                        onMouseLeave={onDeviceBtnHoverStop}
                        onBlur={onDeviceBtnHoverStop}
                    >
                        <IconButton
                            className="subusers__item-menu-btn"
                            onClick={onDeleteDeviceOpen}
                        >
                            <DeleteIcon className="subusers__item-menu-ico" />
                        </IconButton>
                    </Tooltip>
                </ListItemButton>
            </Tooltip>
            <Divider />
        </>
    );
};

const SubuserDeviceItemComponent = React.memo(Component);

export default SubuserDeviceItemComponent;
